<template>
    <div class="q-open-app" @click="openQimaoApp">
        <slot>
            <p class="default-btn">去七猫免费小说APP</p>
        </slot>
        <template v-if="storeCommon.systemInfo.isWeixin">
            <wx-open-launch-app id="launch-btn" appid="wx4ab005521f9f1c04" :extinfo="wxConfig.extinfo">
                <script v-is="'script'" type="text/wxtag-template">
                    <style>.btn{position:absolute;left:0;top:0;width:100%;height:100%}</style>
                    <div class="btn"></div>
                </script>
            </wx-open-launch-app>
        </template>
        <div class="guide" v-if="openFromOthers" @click.stop="openFromOthers = false">
            <img class="guide-img" src="@common/assets/images/web-open-guide.png" alt="" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { apiInitWxConfig } from '@common/http/api';
import { ref, PropType, onMounted, computed } from 'vue';
import { useStoreCommon } from '@common/store/common';

/* 微信sdk打开时，拼接不了channel(客户端内部处理有bug)，需要业务自行处理（如：传递参数+埋点上报）  */
interface IPropsParams {
    /* 打开app跳转的页面url - 其他浏览器 */
    url: string;
    /* 市场推广的channel */
    channel?: string;
}
const props = withDefaults(
    defineProps<{
        params: IPropsParams;
    }>(),
    {
        params: () => ({
            url: '',
        }),
    }
);
const storeCommon = useStoreCommon();
const emits = defineEmits(['buttonShow', 'buttonClick']);
const openFromOthers = ref(false); // 是否从其他app打开
const wxConfig = ref<Record<string, any>>({});
let showWxNativeComp = false;
const setWxConfig = async() => {
    if (!storeCommon.systemInfo.isWeixin) {
        return;
    }
    const wxSdk = await import('weixin-js-sdk');
    const res = await apiInitWxConfig(location.href.split('#')[0]);
    const { appId, timestamp, nonceStr, signature, } = res.data;
    wxConfig.value = { appId, extinfo: schemaLink.value.wxOpenUrl, };
    await wxSdk.config({ debug: false, appId, timestamp, nonceStr, signature, jsApiList: [], openTagList: ['wx-open-launch-app'], });
    showWxNativeComp = true;
    wxSdk.error((res: any) => {
        console.log('wx error', res);
        showWxNativeComp = false;
        emits('buttonShow');
    });

    const btn = document.getElementById('launch-btn');
    // config配置挂载完毕
    btn?.addEventListener('ready', () => {
        console.log('ready');
        emits('buttonShow', 'weChat');
    });
    // 点击打开app微信操作
    btn?.addEventListener('launch', () => {
        console.log('success');
        emits('buttonClick', 'weChat');
    });
    // 在复制链接里打开会出现launch:fail的情况，走原始逻辑，打开引导 - 自测可先收藏
    btn?.addEventListener('error', (err: any) => {
        console.log('error', err);
        openFromOthers.value = true;
    });
};

const schemaLink = ref({
    wxOpenUrl: '',
    openUrl: '',
    downUrl: '',
});
const getSchemaLink = () => {
    const { channel, url, } = props.params;
    const { isIos, } = storeCommon.systemInfo;
    const androidDeeplink = `freereader://webview_newweb?param=${JSON.stringify({ url, })}`;
    const iosDeeplink = `freereader://webview_newweb?param=${JSON.stringify({ url: encodeURIComponent(url), })}&skipad=1`;
    const iosWxDeeplink = `freereader://webview_newweb?param=${JSON.stringify({ url, })}&skipad=1`;
    const androidDownlink = `https://download.wtzw.com/v2.0/qm-${channel || 'mshare'}.apk`;
    const iosDownlink = `https://itunes.apple.com/cn/app/id1387717110`;
    const wxOpenUrl = isIos ? iosWxDeeplink : androidDeeplink;
    let openUrl = isIos ? iosDeeplink : `freereader://xiaoshuo.km.com/adload?param=${encodeURIComponent(androidDeeplink)}&skipad=1`;
    if (channel) {
        const channelQuery = `channel=${channel}&token=1`;
        if (isIos) {
            openUrl = `freereader://load?param=${encodeURIComponent(iosDeeplink)}&${channelQuery}`;
        } else {
            openUrl += `&${channelQuery}`;
        }
    }
    const downUrl = isIos ? iosDownlink : androidDownlink;
    schemaLink.value = {
        wxOpenUrl,
        openUrl,
        downUrl,
    };
    console.log('-- schemaLink', schemaLink.value);
};

let timer: number = 0;
const openQimaoApp = () => {
    const { isWeixin, isQQ, isWeibo, } = storeCommon.systemInfo;
    if (isWeixin && showWxNativeComp) {
        return;
    }
    emits('buttonClick', 'default');
    if (isWeixin || isQQ || isWeibo) {
        openFromOthers.value = true;
        return;
    }
    const { openUrl, downUrl, } = schemaLink.value;
    window.open(openUrl, '_self');
    timer = setTimeout(() => {
        window.open(downUrl, '_self');
    }, 3000);
};
onMounted(async() => {
    getSchemaLink();
    // 分享使用逻辑
    // 1、分享出去链接位app-share.wtzw.com域名，原因手机系统下载七猫app会记录xiaoshuo.wtzw，会超越控制，影响使用
    // 2、在外部浏览器打开中，页面初始化不能调用scheme，不然会越过打开app，无法进入目标页

    setWxConfig();
    // 监听页面变化
    document.addEventListener(
        'visibilitychange',
        () => {
            if (timer) {
                clearTimeout(timer);
            }
        },
        false
    );
});
</script>
<style lang="scss">
#launch-btn {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999;
}
</style>
<style lang="scss" scoped>
.q-open-app {
    position: relative;
    height: 100%;

    .default-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 88px;
        background: linear-gradient(90deg, #ffe040 0%, #fcc800 100%);
        border-radius: 88px;
        font-size: 32px;
        text-align: center;
        font-weight: bold;
        color: #222;
    }

    .guide {
        background-color: rgba(0, 0, 0, 0.7);
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;

        &-img {
            width: 100%;
        }
    }
}
</style>
